import React, { useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Table,
} from "reactstrap";
import Image from "next/image";

import classes from "@/styles/partners/partner.module.css";
import { partner } from "@/utils/content";

const IntegrationDetails = ({ partnerDetails }: any) => {
  const content = partner.en;
  const [open, setOpen] = useState<string>("1");

  //@ts-ignore
  const toggle = (id) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <section className="mb-5 mt-5">
      {
        <Accordion
          className="my-4"
          open={open}
          //@ts-ignore
          toggle={toggle}
        >
          <AccordionItem>
            <AccordionHeader targetId="1">
              {content.requirement}
            </AccordionHeader>
            <AccordionBody accordionId="1">
              <p className="fw-bold">{content.integrationRequirements}</p>
              <ul>
                {partnerDetails.section6?.integration &&
                  partnerDetails.section6?.integration.requirements &&
                  partnerDetails.section6?.integration.requirements.map(
                    (r: string, i: number) => <li key={r + i}>{r}</li>
                  )}
              </ul>
            </AccordionBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionHeader targetId="2">{content.connect}</AccordionHeader>
            <AccordionBody accordionId="2">
              <p>
                {content.followSteps}&nbsp;{partnerDetails.name}
                &nbsp;{content.toShipVista}
              </p>
              <ol className={classes.ol}>
                {partnerDetails.section6?.integration &&
                  partnerDetails.section6?.integration.connect &&
                  partnerDetails.section6?.integration.connect.map(
                    (i: any, index: any) => (
                      <li key={`${i.id}${index}`}>
                        <p>{i.list}</p>
                        {i.img && (
                          <Image
                            className={classes.listImg}
                            src={i.img}
                            alt={i.img}
                            height={300}
                            width={200}
                          />
                        )}
                      </li>
                    )
                  )}
              </ol>
            </AccordionBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionHeader targetId="3">
              {content.availableFeatures}
            </AccordionHeader>
            <AccordionBody accordionId="3">
              <p>
                {content.shipvistaIntegration}&nbsp;
                {partnerDetails.name}&nbsp;{content.supports}
              </p>
              {partnerDetails.section6?.integration &&
                partnerDetails.section6?.integration.features && (
                  <>
                    <p className="fw-bold mb-1">
                      {content.commonIntegrationFeatures}
                    </p>
                    <Table striped bordered hover>
                      <thead className="bg-dark text-white">
                        <tr>
                          <th className="w-75">{content.feature}</th>
                          <th className="">{content.support}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {partnerDetails.section6?.integration.features &&
                          partnerDetails.section6?.integration.features.map(
                            (f: any) => {
                              return (
                                <tr key={f.name}>
                                  <td>{f.name}</td>
                                  <td>{f.status}</td>
                                </tr>
                              );
                            }
                          )}
                      </tbody>
                    </Table>
                  </>
                )}
              {/* <p className="fw-bold mb-1">{content.shipvistaUpdate}</p> */}
              {partnerDetails.section6?.integration &&
                partnerDetails.section6?.integration.shipVistaStatus && (
                  <Table striped bordered hover>
                    <thead className="bg-dark text-white">
                      <tr>
                        <th className="w-75 fw-light">
                          {content.shipvista}&nbsp;{content.status}
                        </th>
                        <th className="fw-light">
                          {partnerDetails.name}&nbsp;
                          {content.status}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {partnerDetails.section6?.integration.shipVistaStatus &&
                        partnerDetails.section6?.integration.shipVistaStatus.map(
                          (f: any) => {
                            return (
                              <tr key={f.name}>
                                <td>{f.name}</td>
                                <td>{f.status}</td>
                              </tr>
                            );
                          }
                        )}
                    </tbody>
                  </Table>
                )}
              {partnerDetails.section6?.integration &&
                partnerDetails.section6?.integration.shipvistaUpdate && (
                  <>
                    <p className="fw-bold mb-1">{content.shipvistaUpdate}</p>
                    <Table striped bordered hover>
                      <thead className="bg-dark text-white">
                        <tr>
                          <th className="w-75 fw-light">{content.field}</th>
                          <th className="fw-light">{content.support}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {partnerDetails.section6?.integration.shipvistaUpdate &&
                          partnerDetails.section6?.integration.shipvistaUpdate.map(
                            (f: any) => {
                              return (
                                <tr key={f.name}>
                                  <td>{f.name}</td>
                                  <td>{f.status}</td>
                                </tr>
                              );
                            }
                          )}
                      </tbody>
                    </Table>
                  </>
                )}
            </AccordionBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionHeader targetId="4">
              {content.additionalDetails}
            </AccordionHeader>
            <AccordionBody accordionId="4">
              <ul>
                <li>
                  <p className="text-decoration-underline">
                    {partnerDetails.section6?.integration &&
                    partnerDetails.section6?.integration.additionalDetails
                      ? partnerDetails.section6?.integration.additionalDetails
                      : "N/A"}
                  </p>
                </li>
              </ul>
            </AccordionBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionHeader targetId="5">
              {content.troubleshooting}
            </AccordionHeader>
            <AccordionBody accordionId="5">
              <p>
                {partnerDetails.section6?.integration &&
                partnerDetails.section6?.integration.troubleshooting
                  ? partnerDetails.section6?.integration.troubleshooting
                  : "N/A"}
              </p>
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      }
    </section>
  );
};

export default IntegrationDetails;
